import { useState, useEffect } from "react";
/*****You probably don't need to use this.*** Currently used to ensure onBlur behaviour updates state
 * before hotkeys are triggered - see the Hotkey control (not hook) for more info.
 * @param effect The function to run
 * @param waitTillNextRender Whether to actually wait - if false then the function returned will just be the passed in function. This is needed in order to preserve hook call order when the waiting is conditional.
 */
export function useDelayedEffect(effect, waitTillNextRender = true) {
    const [shouldPerformEffect, setShouldPerformEffect] = useState(false);
    useEffect(() => {
        if (shouldPerformEffect && waitTillNextRender) {
            setShouldPerformEffect(false);
            effect();
        }
    }, [shouldPerformEffect, effect, waitTillNextRender]);
    return () => (waitTillNextRender ? setShouldPerformEffect(true) : effect());
}
